import { Component, Input, OnInit, ContentChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { SelectOptionComponent } from './select-option/select-option.component';
import { Option } from './select.types';

export interface SelectOption {
  name: string;
  value: string | number;
  selected?: boolean;
}

@Component({
  selector: 'form-select',
  templateUrl: './select.component.html'
})
export class SelectComponent implements OnInit {
  // @Input() icon: string;
  // @Input() name: string;
  // @Input() label: string;
  @Input() required = false;
  @Input() disabled = false;
  @Input() items;
  // @Input() selectedValue: any;
  // @Input() options: SelectOption[];

  @Input() placeholder = "This is a placeholder";
  isOpen = true;

  selectedItem: Option;
  hoveredItem: Option;

  constructor(
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit() {
  }

  handleMousedown(event) {

    this.toggle();
  }

  clearSelection() {
    this.unselect();
  }

  toggleItem(item: Option) {

    if (!item || this.disabled) {

      return;
    }

    this.select(item);
  }

  select(item: Option) {

    this.selectedItem = item;
    this.close();
  }

  unselect() {

    this.selectedItem = null;
  }

  onItemHover(item: Option) {

    if (!this.selectedItem) {
      this.hoveredItem = item;
      return;
    }

    if (item.value !== this.selectedItem.value) {
      this.hoveredItem = item;
    } else {
      this.hoveredItem = null;
    }
  }

  open() {

    if (this.isOpen) {

      return;
    }

    this.isOpen = true;
  }

  close() {
    if (!this.isOpen) {

      return;
    }

    this.isOpen = false;
    this.cd.detectChanges();
  }

  toggle() {

    if (!this.isOpen) {

      this.open();
    } else {

      this.close();
    }
  }
}
